import { render, staticRenderFns } from "./itemsTable.vue?vue&type=template&id=006a8806&"
import script from "./itemsTable.vue?vue&type=script&lang=ts&"
export * from "./itemsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports